import TbkWistia from '../../tbk-utils/video/tbk-helpers'

const TbkVideoMixin = {
  data() {
    return {
      tbk: null
    }
  },

  mounted() {
    this.tbk = new TbkWistia()
  }

}

export default TbkVideoMixin
